import moment from 'moment';


export const fromDateStr = d => d?.clone().set({ 'hour': 0, 'minute': 0, 'second': 0 }).utc().format()

export const toDateStr = d => d?.clone().set({ 'hour': 23, 'minute': 59, 'second': 59 }).utc().format()
